import { Component, Input } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-resource-search-card",
    templateUrl: "./resource-search-card.component.html",
    styleUrls: ["./resource-search-card.component.less"],
})
export class ResourceSearchCardComponent extends CardComponent {
    @Input() public gtmDataCardNumber: number

    constructor(public userService: UserService) {
        super(userService)
    }
}
